var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-default-layout",staticStyle:{"overflow":"auto"}},[_c('keep-alive',{attrs:{"max":200}},[(_vm.$route.meta.keepAlive)?_c('router-view'):_vm._e()],1),(!_vm.$route.meta.keepAlive)?_c('router-view'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }